module.exports = __webpack_public_path__ + "img/code-analyzer01.d2f31b07.jpg";